<div class="header header-simple container">
  <div class="mid-header">
    <div class="logo-wrapper d-none d-md-block">
      <a
        class="logo"
        data-testing-id="header-home-link-desktop"
        rel="home"
        routerLink="/home"
        [attr.aria-label]="'common.home.link' | translate"
      ></a>
    </div>
    <div class="logo-wrapper d-sm-none">
      <a
        class="mobile-logo"
        data-testing-id="link-home"
        rel="home"
        routerLink="/home"
        [attr.aria-label]="'common.home.link' | translate"
      ></a>
    </div>
  </div>
</div>
